import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ERR_ATM_ID_NUMBER_FORMAT: {
    id: 'milan_atm_error_invalid_id_number',
    defaultMessage: 'ID Number must be between 1-4 digits long'
  },
  ERR_ATM_FISCAL_NUMBER_INVALID_LENGTH: {
    id: 'milan_atm_error_wrong_fiscal_code_length',
    defaultMessage: 'Fiscal code must be 16 characters long'
  },
  ERR_ATM_SERIAL_NUMBER_INVALID_LENGTH: {
    id: 'milan_atm_error_wrong_serial_number_length',
    defaultMessage: 'Serial number must be 9 digits long'
  },
  identificationNumber: {
    id: 'milan_atm_card_id_number',
    defaultMessage: 'ID number'
  },
  serialNumber: {
    id: 'milan_atm_card_serial_number',
    defaultMessage: 'Serial number'
  },
  fiscalCode: {
    id: 'milan_atm_fiscal_code',
    defaultMessage: 'Fiscal code'
  },
  atmCardNotValid: {
    id: 'milan_atm_card_not_valid',
    defaultMessage: 'Card is not valid'
  },
  atmApplyDiscount: {
    id: 'milan_atm_apply_discount',
    defaultMessage: 'Apply ATM discount'
  },
  publicTransportCard: {
    id: 'public_transport_card',
    defaultMessage: 'Public transport card'
  },
  milan_atm_card_added: {
    id: 'milan_atm_card_added',
    defaultMessage: 'ATM card added! Now you can use it for taking bikes.'
  },
  milan_atm_card_removed: {
    id: 'milan_atm_card_removed',
    defaultMessage:
      'ATM card removed. You can no longer use it for taking bikes.'
  },
  milan_atm_confirm_remove: {
    id: 'milan_atm_confirm_remove',
    defaultMessage: 'Do you want to remove your ATM card?'
  }
});
